import React, {Fragment, useEffect, useState} from "react";
import {AccountBalanceResult, Affiliate, MultiFactorAuthStatus, TransactionResult, User, Product, AdminNote, AffiliatesListRequest, MultiBalanceDto} from "../../http/protocol";
import {getContainer} from "../../ioc/IOCSetup";
import {RouteComponentProps, withRouter} from "react-router";
import {AttributePanel} from "../AttributePanel";
import {formatDate} from "../../util/date";
import {Link} from "react-router-dom";
import {AccountBalances} from "./UserAccountBalances";
import {UserTransactionPanel} from "./UserTransactionPanel";
import {AdminNotes} from "../notes/AdminNotes";
import UserPaymentHistory from "./UserPaymentHistory";
import {UserCryptoAddressHistory} from "./UserCryptoAddressHistory";
import UserLabelsComponent from "./UserLabelsComponent";
import {UserBonusComponent} from "./UserBonusComponent";
import UserBonusHistory from "./UserBonusHistory";
import PlayerAudit from "../audits/PlayerAudits";
import { QuickEdit } from "../QuickEdit";
import { UserBlocked } from "../UserBlockedBySwitch";
import SystemEventView from "../audit/SystemEventView";
import UserMetrics from "./UserMetrics";

interface PokerRakeProps {
    userId: number;
}

const PokerRake: React.FC<PokerRakeProps> = (props: PokerRakeProps) => {
    const analyticsService = getContainer().getMetricsService();

    const [selectedCurrency, setSelectedCurrency] = useState(localStorage.getItem("activeCurrency") || "mBTC");
    const [selectedDateForPR, setSelectedDateForPR] = useState<string>(new Date().toISOString().slice(0,7));
    const [pokerRake, setPokerRake] = useState<number  | undefined>(undefined);
    const [pokerTier, setPokerTier] = useState<string  | undefined>(undefined);

    const getTier = (rake:number) =>{
        let tier = null;
            if (rake >= 1000)
              tier = "35%";
            else if (rake >= 250 && rake <= 999.99)
              tier = "30%";
            else if (rake >= 100 && rake <= 249.99)
              tier = "25%";
            else if (rake >= 50 && rake <= 99.99)
              tier = "20%";
            else if (rake >= 10 && rake <= 49.99)
              tier = "15%";
            else if (rake >= 3 && rake <= 9.99)
              tier = "10%";
            else
              tier = "0%";
        return tier;
    }

    const getSumByUserId = (currency:string, firstDay:string, lastDay:string, userId:any) =>{
        analyticsService.getSumByUserId("REVENUE","POKER", currency, firstDay, lastDay, userId, "MAIN").then(points => {

            let apoints = points['points'] || [];
            let rake = 0;
            apoints.forEach((point, index) => {
                rake += point['value']!;//no se encuentra el value
              });
           
            setPokerRake(rake);
            let tier = getTier(rake);
            setPokerTier(tier);
        });

    }

    const loadPokerRake = async(monthDate: string | undefined | null = null)=>{  
        //get first and last day of month from selected date for PR
        let firstDate = new Date(monthDate! + "-01");

        //get last day of month
        let lastDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 2, 0);
        
        //format dates to yyyy-mm-dd
        let firstDateString : string = new Date(firstDate).toISOString().slice(0,10);
        let lastDateString: string = new Date(lastDate).toISOString().slice(0,10);
        
        
        getSumByUserId(selectedCurrency, firstDateString, lastDateString, props.userId); 
    }

    useEffect(() => {
        loadPokerRake(selectedDateForPR);
    },[selectedDateForPR]);

    return (
        <div className="card-box d-flex">
            <h4 className="col-lg-7">Poker Rake: {pokerRake} mBTC | {pokerTier} Rakeback</h4>
            <div className={"col-lg-5"}>
                <input type={"month"} value={selectedDateForPR} onChange={(e)=>{setSelectedDateForPR(e.target.value)}} className={"form-control"} placeholder={"Name in Language"}/>
            </div>
        </div>
    )
}

interface Props extends RouteComponentProps {

}

const UserView: React.FC<Props> = (props: Props) => {

    const service = getContainer().getUserService();
    const wallet = getContainer().getWalletService(); 
    const multibalanceService = getContainer().getMultiBalanceService();
    const affiliateService = getContainer().getAffiliatesService();
    const providerService = getContainer().getProviderService();
    const userAuthenticationService = getContainer().getUserAuthenticationService();
    const [user, setUser] = useState<User>({});
    const [cashoutAffiliates, setCashoutAffiliates] = useState([]);
    const [id, setId] = useState((props.match.params as any).id);
    const [groupPermissionEnabledProduct, setGroupPermissionEnabledProduct] = useState(false);
    const [groupPermissionAccountAttributes, setGroupPermissionAccountAttributes] = useState(false);
    const [accounts, setAccounts] = useState<AccountBalanceResult[]>([]);
    const [multibalances, setMultibalances] = useState<MultiBalanceDto[]>([]);
    const [userLabels, setUserLabels] = useState<string[]>([]);
    const [lookupExpanded, setLookupExpanded] = useState(false);
    const [lookupExpandedSetting, setLookupExpandedSetting] = useState(false);
    const [enabledProducts, setEnabledProducts] = useState<string[]  | undefined>([]);

    const loadAffiliates = async(request: AffiliatesListRequest, id:number) =>{
        await affiliateService.getAffiliateByCashoutUserId(id, request)
        .then((affList:any) => {
            setCashoutAffiliates(affList.items);
        })
        .catch(e=>{
            setCashoutAffiliates([]);
        });
    }

    const permissionEnabledProduct = async () =>{
        await userAuthenticationService.getGroupPermissions()
        .then(x=>{
            let value = x["ENABLED_PRODUCTS"];
            if(value===undefined || value===false){
                setGroupPermissionEnabledProduct(value);
            }else{
                setGroupPermissionEnabledProduct(true);
            }
        })
    }

    const permissionAccountAttributes = async () =>{
        await userAuthenticationService.getGroupPermissions().then(x=>{
            let value = x["ACCOUNT_ATTRIBUTES"];
            if(value===undefined || value===false){
                setGroupPermissionAccountAttributes(value);
            }else{
                setGroupPermissionAccountAttributes(true);
            }
        })
    }

    const refreshBalances = async (id:string, username:string) => {
        
        const [accounts, balances] = await Promise.all([
            wallet.getAccountBalances(id),
            multibalanceService.getBalances(id, username)
        ]);
        
        setAccounts(accounts);
        setMultibalances(balances);
    }

    const renderMultiFactorAuthentication = () => {
        if (user && user.mfaStatus === MultiFactorAuthStatus.ENABLED) {
            return user.mfaProvider
        } else {
            return (<span className="text-muted">Not set</span>)
        }
    }
    const getUser= async (id:any) => {
        setId(id);
        await service.getEntity(id)
        .then((data:User)=>{
            setUser(data);
            setEnabledProducts(data.enabledProducts);
            setUserLabels(data.labels as string[]);
            loadAffiliates({"offset":0,"limit":100,"ascending":false, "orderBy": "created"}, id);
            permissionEnabledProduct();
            permissionAccountAttributes();
            refreshBalances(id, data.username || "");
        })
      .catch(e=>{
        console.error("Error gettting user  endpoint");
        localStorage.setItem("dailyLoginGraphData", "");
      });
    }

    const updateProductEnabled=(product: Product, enable: boolean)=> {
        if (user === undefined) {
            return;
        }

        service.updateProductEnabled(user.id, product, enable
            ).then(() => {
                getUser(id);
            }).catch(() => {
                alert(`You can only type: true or false`);
            });
    }

    const getTitle = () =>{
        return "User Overview";
    }

    const updateAffiliate = (affiliateId: number) =>{
        if (user === undefined) 
            return ;

        affiliateService.setAffiliate(affiliateId, {
            playerId: user.id,
            username: user.email
        }).then((aff: Affiliate) => {
            user.affiliateName = aff.username;
            user.affiliateId = aff.id;
            let commentAff = `Tagged Affiliate ${aff.id} [${aff.username}] to User ${user.id}`;
            let note : AdminNote  ={
                type : "USER",
                typeId :user.id + "",
                comment : commentAff || ""
            };
    
            if (note.comment && note.comment.length !== 0 && note.comment.trim().length !== 0) {
                getContainer().getAdminNotesService().save(note);
            }
            setUser(user);
        }).catch(() => {
            alert(`Unable to update affiliate. Please check if Affiliate ID [${affiliateId}] exists. Otherwise, please contact administrator.`);
        });
    }
    useEffect(() => {
        getUser(id);
    },[id]);
    
    return(
        <Fragment>
        <div className="row">
            <div className={"col-lg-5"}>
                <div className={"row"}>
                    <div className="col-lg-12">
                        <div className={"card-box"}>
                            <Link to={"/user/edit/" + user.id} className={"btn btn-warning"} style={{float : "right"}}><i className={"fe-edit"}></i> Edit User</Link>
                            <h4>{user.email}</h4>
                            <h5>User Id: {user.id}</h5>
                            <UserLabelsComponent userLabels={userLabels} userId={id}/>
                            <table className={"table table-striped"}>
                                <tbody>
                                {user.attributes && user.attributes['pokerUserId'] && (
                                    <tr>
                                        <td>Poker User ID</td>
                                        <td>
                                            {user.attributes['pokerUserId']}
                                            {providerService.getCubeiaDashboardUrl()&& (
                                                <a rel="noreferrer"  href={`${providerService.getCubeiaDashboardUrl()}/user/${user.attributes['pokerUserId']}`} target="_blank" className="btn btn-sm btn-primary float-right">View in Dashboard</a>
                                            )}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td>Username</td>
                                    <td>{user.username}</td>
                                </tr>
                                <tr>
                                    <td>Phone Number</td>
                                    <td>{user.phoneNumber}</td>
                                </tr>
                                <tr>
                                    <td>Phone Verified</td>
                                    <td>{user.phoneNumberVerified ? <span className={"Yes"}>Yes</span>: <span className={"red"}>No</span>}</td>
                                </tr>
                                <tr>
                                    <td>Blocked</td>
                                    <td>{user.blocked ? <span className={"red"}>Yes</span>: <span className={"green"}>No</span>}</td>
                                </tr>
                                <tr style={{display:"none"}}>
                                    <td>KYC Verified</td>
                                    <td>{user.kycVerified ? <span className={"green"}>Yes</span>: <span className={"red"}>No</span>} <span className="badge badge-blue">{user.kycStatus != null ? user.kycStatus : "NOT_STARTED"}</span></td>
                                </tr>
                                <tr>
                                    <td>Email Verified</td>
                                    <td>{user.emailVerified ? <span className={"Yes"}>Yes</span>: <span className={"red"}>No</span>}</td>
                                </tr>
                                <tr>
                                    <td>Credit Enabled</td>
                                    <td>{user.creditEnabled ? <span className={"red"}>Yes</span>: <span className={"green"}>No</span>}</td>
                                </tr>
                                <tr>
                                    <td>Created</td>
                                    <td>{formatDate(user.created)}</td>
                                </tr>
                                <tr>
                                    <td>Created Remote Address</td>
                                    <td>{user.createdRemoteAddress}</td>
                                </tr>
                                <tr>
                                    <td>Last Login</td>
                                    <td>{formatDate(user.lastLogin)}</td>
                                </tr>
                                <tr>
                                    <td>Login Type</td>
                                    <td>{user.loginType}</td>
                                </tr>
                                <tr>
                                    <td>Affiliate ID</td>
                                    <td>
                                        <QuickEdit 
                                            defaultValue={user.affiliateId? user.affiliateId+"": ""} 
                                            onSubmit={(affId: number) => updateAffiliate(affId)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Affiliate Name</td>
                                    <td>{user.affiliateName}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>{user.email}</td>
                                </tr>
                                <tr>
                                    <td>Country Code</td>
                                    <td>{user.country}</td>
                                </tr>
                                <tr>
                                    <td>Two-Factor Authentication</td>
                                    <td>{renderMultiFactorAuthentication()}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {groupPermissionEnabledProduct!==undefined && (
                        <div className="col-lg-12">
                            <div className={"card-box"}>
                                <h4> Enabled Products </h4>
                                <div className="hr-line-dashed"></div>
                                <table className={"table table-striped"}>
                                    <tbody>
                                        {
                                            
                                            Object.values(Product).map((x:Product) => {
                                                return(
                                                <tr>
                                                    <td>{x}</td>
                                                    <td>
                                                        <UserBlocked
                                                            defaultValue={enabledProducts!.includes(x)}
                                                            onSubmit={(enable: boolean) => updateProductEnabled( x, enable)}
                                                            inputType={"checkbox"}
                                                            enabledProductPermission={groupPermissionEnabledProduct}
                                                        />
                                                        
                                                    </td>
                                                </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                    
                    <div className="col-lg-12">
                        <AccountBalances userId={id} username={user.username} balances={multibalances} />
                    </div>
                    <div className="col-lg-12">
                        <UserTransactionPanel accounts={accounts} onTransferComplete={(tr : TransactionResult) => { refreshBalances((user.id||"").toString(), (user.username||"").toString()) }} service={wallet}/>
                    </div>
                    <div className="col-lg-12">
                        <UserBonusComponent userId={id as number} />
                    </div>

                    <div className="col-lg-12">
                        {user && <PokerRake userId={id as number} />}
                    </div>

                    {groupPermissionAccountAttributes!==undefined && (
                                           <div className="col-lg-12">
                                           <div className={"card-box expandable-box"}  style={!lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !lookupExpanded ? setLookupExpanded(true) : null}>
                                {lookupExpanded && (
                                        <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); setLookupExpanded(false);}}><i className="mdi mdi-minus"></i></a>
                                    )}
                                    {!lookupExpanded && (
                                        <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault();setLookupExpanded(true);}}><i className="mdi mdi-plus"></i></a>
                                    )}
                                {!lookupExpanded &&(<div style={{marginBottom:10}} className="" onClick={()=>setLookupExpanded (!lookupExpanded)}>
                                    <h4>User Attributes</h4>
                                </div>)}
                                 {lookupExpanded && user.attributes && (
                                    <AttributePanel attributes={user.attributes} header={"User Attributes"}/>
                                 )}
                        </div> </div>
                    )}
                    

                    <div className="col-lg-12">
                    <div className={"card-box expandable-box"}  style={!lookupExpandedSetting ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !lookupExpandedSetting ? setLookupExpandedSetting(true) : null}>
                                {lookupExpandedSetting && (
                                        <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); setLookupExpandedSetting(false);}}><i className="mdi mdi-minus"></i></a>
                                    )}
                                    {!lookupExpandedSetting && (
                                        <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault();setLookupExpandedSetting(true);}}><i className="mdi mdi-plus"></i></a>
                                    )}
                                {!lookupExpandedSetting &&(<div style={{marginBottom:10}} className="" onClick={()=>setLookupExpandedSetting (!lookupExpanded)}>
                                    <h4>User Settings</h4>
                                </div>)}
                                 {lookupExpandedSetting && user.userSettings && (
                            <AttributePanel attributes={user.userSettings} header={"User Settings"}/>
                        )}
                    </div>
                </div>
                </div>
            </div>


            <div className={"col-lg-7"}>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <AdminNotes type={"USER"} typeId={""+id} title={"User Notes"}/>
                    </div>
                </div>

                {cashoutAffiliates && (
                    cashoutAffiliates.map((mapping:any) => (
                        <div className={"row"}>
                            <div className={"col-lg-12"}>
                                <AdminNotes type={"AFFILIATE"} typeId={""+mapping.id} title={"Affiliate " + mapping.id + " Notes"}/>
                            </div>
                        </div>
                    ))
                )}
                
                <div className={"row"}>
                    <div className={"col-12"}>
                        <UserMetrics userId={id && id ? id.toString() : ""} accounts={accounts}/>
                    </div>
                </div>
                <div className={"row"}>
                    <UserPaymentHistory params={{id:id ? id.toString() : ""}}/>
                </div>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <SystemEventView userId={id as number} />
                    </div>
                </div>                   
                <div className={"row"}>
                    <UserBonusHistory userId={id  as number} />
                </div>  
                <div className={"row"}>
                    <div className={"col-12"}>
                        <PlayerAudit userId={id as number} />
                    </div>
                </div>
                <div className={"row"} style={{visibility:"hidden"}}>
                    <UserCryptoAddressHistory params={{id:id ? id.toString() : ""}}/>
                </div>
            </div>
        </div>
    </Fragment>
    )
}
export default withRouter(UserView);

